export interface TranslationLabels {
  [key: string]: {
    [key: string]: string
  }
}

export const Labels: TranslationLabels = {
  nl: {
    // Headers
    logIn: 'Inloggen',
    register: 'Registreren',
    forgotPassword: 'Wachtwoord vergeten',
    resetPassword: 'Nieuw wachtwoord instellen',
    verification: 'Verificatie',
    editProfile: 'Gegevens bewerken',
    Zoeken: 'Zoeken',

    // Buttons
    createAccount: 'Account aanmaken',
    submit: 'Versturen',
    save: 'Opslaan',
    send: 'Verzenden',
    cancel: 'Annuleren',
    backToLogin: 'Terug naar inloggen',
    goToLogin: 'Naar inloggen',
    goToRegister: 'Naar registreren',
    updateProfile: 'Gegevens updaten',
    changePassword: 'Wachtwoord wijzigen',
    iHaveAccount: 'Ik heb al een account',

    // Form fields
    email: 'E-mailadres',
    password: 'Wachtwoord',
    firstName: 'Voornaam',
    lastName: 'Achternaam',

    // Messages
    accountActivated: 'Uw account is geactiveerd. U kunt nu inloggen.',
    accountRegistered:
      'Uw account is succesvol geregistreerd. Er wordt een e-mail verstuurd naar uw e-mailadres voor het activeren van uw account.',
    passwordResetSuccess: 'Uw nieuwe wachtwoord is ingesteld. U kunt nu inloggen.',
    passwordResetEmailSent: 'We hebben een link gestuurd naar je e-mailadres voor het resetten van je wachtwoord!',
    profileUpdateSuccess: 'Uw gegevens zijn successvol aangepast.',
    forgotPasswordInstructions:
      'Vul hieronder je e-mailadres in en we sturen je een link om je wachtwoord opnieuw in te stellen.',
    back: 'Terug',

    // Error messages
    invalidPage: 'Ongeldige pagina',

    // Accessibility
    accessibility: 'Toegankelijkheid',
    lowStimulus: 'Prikkelarm',
    highContrast: 'Hoog contrast',
    largerText: 'Grotere tekst',

    price: 'Prijs',
    date: 'Datum',
    time: 'Tijd',
    location: 'Locatie',
  },
  en: {
    // Headers
    logIn: 'Log in',
    register: 'Register',
    forgotPassword: 'Forgot password',
    resetPassword: 'Set new password',
    verification: 'Verification',
    editProfile: 'Edit profile',
    Zoeken: 'Search',

    // Buttons
    createAccount: 'Create account',
    submit: 'Submit',
    save: 'Save',
    send: 'Send',
    cancel: 'Cancel',
    backToLogin: 'Back to login',
    goToLogin: 'Go to login',
    goToRegister: 'Go to register',
    updateProfile: 'Update profile',
    changePassword: 'Change password',
    iHaveAccount: 'I already have an account',

    // Form fields
    email: 'Email address',
    password: 'Password',
    firstName: 'First name',
    lastName: 'Last name',

    // Messages
    accountActivated: 'Your account has been activated. You can now log in.',
    accountRegistered:
      'Your account has been successfully registered. An email will be sent to your email address to activate your account.',
    passwordResetSuccess: 'Your new password has been set. You can now log in.',
    passwordResetEmailSent: 'We have sent a link to your email address to reset your password!',
    profileUpdateSuccess: 'Your profile has been successfully updated.',
    forgotPasswordInstructions: 'Enter your email address below and we will send you a link to reset your password.',
    back: 'Back',

    // Error messages
    invalidPage: 'Invalid page',

    // Accessibility
    accessibility: 'Accessibility',
    lowStimulus: 'Low stimulus',
    highContrast: 'High contrast',
    largerText: 'Larger text',

    price: 'Price',
    date: 'Date',
    time: 'Time',
    location: 'Location',
  },
}
